// extracted by mini-css-extract-plugin
export default {"section":"ideadetail_section__KQKxp","card":"ideadetail_card__bgl6v","buttonContainer":"ideadetail_buttonContainer__BUDn6"};